<div>
  <div class="d-flex align-items-start m-b-10 p-x-10 m-y-30">
    @if (selectedCategory) {
      <button type="button" class="back-btn m-r-10 p-0 border-0" (click)="goBack()" (keyup.enter)="selectedCategory = undefined">
        <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
        <span class="sr-only">back</span>
      </button>
    }
    @if (!selectedSection) {
      <fui-heading [text]="selectedCategory ? (selectedCategory.name == 'Studio One Plus' ? 'Studio One Pro+' : selectedCategory.name) : ('support.categories' | translate)" [level]="5"></fui-heading>
    }
    <!-- <fa-icon *ngIf="selectedSection" icon="chevron-left" class="m-x-10"></fa-icon> -->
    @if (selectedSection) {
      <fui-heading [text]="selectedSection.name" [level]="5"></fui-heading>
    }
  </div>
  @if (!selectedCategory) {
    <div class="m-b-20 m-x-10 form-group">
      <label class="control-label" for="search-knowledgebase-articles">{{ "support.search_knowledgebase_articles" | translate }}</label>
      <div class="product-filter">
        <div class="filter-input no-max-width">
          <input
            id="search-knowledgebase-articles"
            type="text"
            [(ngModel)]="query"
            (keyup.enter)="search()"
            (focus)="focused = true"
            (blur)="focused = false"
            [placeholder]="'support.type_to_search_knowledgebase_articles' | translate"
          />
          @if (query) {
            <button type="button" class="clear bg-transparent border-0 p-0" aria-label="clear search" (click)="clear()">
              <fa-icon icon="times" aria-hidden="true"></fa-icon>
              <span class="sr-only">clear search</span>
            </button>
          }
          @if (focused) {
            <div class="text-muted t-12" style="position: absolute; bottom: -20px; left: 0px">Hit enter to search...</div>
          }
        </div>
      </div>
    </div>
  }
  @if (loading) {
    <myp-skeleton-loader type="list-item-large" [number]="5" extraContainerClass="m-b-20"></myp-skeleton-loader>
  }
  @if (!selectedCategory && !searching && !searchResults) {
    <ul class="list-group animate-in-from-left">
      @for (cat of categories; track cat) {
        <li class="list-group-item bg-transparent border-0 p-0">
          <div role="group" aria-label="category">
            <myp-list-item
              [subData]="['Updated: ' + (cat.updated_at | date), cat.description ? cat.description : null]"
              [title]="cat.name == 'Studio One Plus' ? 'Studio One Pro+' : cat.name"
              [photo]="
                cat.name == 'Studio One v6'
                  ? 'https://studioone-content.presonusmusic.com/pictures/presonus-studio-one-6-professional-R-500x500.png?verify=1668543349-u6rlSXK7pTlzaXPTp86ijQRQxJnSVX2UXvc%2FoFi7z6Q%3D'
                  : cat.image
              "
              [imageRound]="false"
              [imageBorder]="false"
              [largeImage]="true"
              (itemClicked)="selectCategory(cat)"
            >
              <div class="button-content">
                <button type="button" class="circle-icon-btn m-r-10 bg-transparent border-0 p-0" placement="left" ngbTooltip="Copy Link To This Category" (click)="copyLink(cat, $event)">
                  <fa-icon icon="link" class="action" aria-hidden="true"></fa-icon>
                  <span class="sr-only">Copy Link To This Category</span>
                </button>
              </div>
            </myp-list-item>
          </div>
        </li>
      }
    </ul>
  }

  @if (selectedCategory && !selectedSection && !searching && !searchResults) {
    <div class="animate-in-from-right">
      @if (loading) {
        <myp-skeleton-loader type="list-item-large" [number]="5" extraContainerClass="m-b-20"></myp-skeleton-loader>
      }
      @if (categorySections && categorySections.length) {
        <ul class="list-group animate-in-from-left">
          @for (section of categorySections; track section) {
            <li class="list-group-item bg-transparent border-0 p-0" role="link" tabindex="0">
              <div role="group" aria-label="category section">
                <myp-list-item
                  [subData]="['Updated: ' + (section.updated_at | date), section.description ? section.description : null]"
                  [title]="section.name"
                  [showImage]="false"
                  (itemClicked)="selectSection(section)"
                >
                  <div class="button-content">
                    <button type="button" class="circle-icon-btn m-r-10 bg-transparent border-0 p-0" placement="left" [ngbTooltip]="'Copy Link To This Section'" (click)="copyLink(section, $event)">
                      <fa-icon icon="link" class="action" aria-hidden="true"></fa-icon>
                      <span class="sr-only">Copy Link To This Section</span>
                    </button>
                  </div>
                </myp-list-item>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }

  @if (selectedCategory && selectedSection && !searching && !searchResults) {
    <div class="animate-in-from-right">
      @if (loading) {
        <myp-skeleton-loader type="list-item-large" [number]="5" extraContainerClass="m-b-20"></myp-skeleton-loader>
      }
      @if (sectionArticles && sectionArticles.length) {
        @for (article of sectionArticles; track article) {
          <myp-list-item
            [subData]="['Created: ' + (article.created_at | date), article.description ? article.description : null]"
            [title]="article.name"
            [showImage]="false"
            (itemClicked)="selectArticle(article)"
          >
            <div class="button-content">
              <button type="button" class="circle-icon-btn m-r-10 bg-transparent border-0 p-0" placement="left" [ngbTooltip]="'Copy Link To This Article'" (click)="copyLink(article, $event)">
                <fa-icon icon="link" class="action" aria-hidden="true"></fa-icon>
                <span class="sr-only">Copy Link To This Article</span>
              </button>
            </div>
          </myp-list-item>
        }
      }
    </div>
  }

  @if (searching || (searchResults && searchResults.results.length)) {
    @if (searching) {
      <myp-skeleton-loader type="list-item" [number]="5" extraContainerClass="m-b-20"></myp-skeleton-loader>
    }
    @if (searchResults && searchResults.results.length) {
      <ul class="list-group">
        @for (article of searchResults.results; track article) {
          <li class="list-group-item bg-transparent border-0 p-0">
            <div role="group" aria-label="article">
              <myp-list-item
                [subData]="['Created: ' + (article.created_at | date), article.description ? article.description : null]"
                [title]="article.name"
                [showImage]="false"
                (itemClicked)="selectArticle(article)"
              >
                <div class="button-content">
                  <button type="button" class="circle-icon-btn m-r-10 bg-transparent border-0 p-0" placement="left" ngbTooltip="Copy Link To This Article" (click)="copyLink(article, $event)">
                    <fa-icon icon="link" class="action" aria-hidden="true"></fa-icon>
                    <span class="sr-only">Copy Link To This Article</span>
                  </button>
                </div>
              </myp-list-item>
            </div>
          </li>
        }
      </ul>
    }
  }

  @if (searchResults && !searchResults.results.length) {
    <p class="text-center text-muted m-t-50">No matching articles found.</p>
  }
  @if (searchResults && (searchResults.results.length || !searchResults.results.length)) {
    <div class="sr-only" aria-live="assertive">{{ searchResults.results.length }} records available.</div>
  }
</div>
